import { ApplicationWithId } from "../../interfaces/IApplications";
import { Box, Typography } from "@mui/material";

interface ApplicationCostProps {
  application: ApplicationWithId;
}

export default function ApplicationCost({ application }: ApplicationCostProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
        Koszt całkowity:
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 600, color: "#6366f1", fontSize: "0.8rem" }}>
        {application.totalCost} zł
      </Typography>
    </Box>
  );
}
